<style lang="stylus">
    .leftPanel
        position: fixed;
        z-index: 2;
        left: 0;
        user-select:none;
        pointer-events: none;
        width 298px;
        background-color var(--bg-color-primary)
        .panel-menu
            position: absolute;
            pointer-events: auto;
            left: 0;
            top: 0;
            width: 48px;
            padding 8px 4px 0 4px;
            // display flex;
            // justify-content center;
            bottom: 0;
            border-radius: 1px;
            z-index: 1;
            background-color $right-view-menucolor
            border-color #EBEBEF
            .panel-normalmenu
                height calc(100% - 60px)
                @media screen and (max-height: 666px)
                    height calc(100% - 36px)
                    overflow-y auto
                    overflow-x hidden
            .panel-menu-link
                display: flex;
                justify-content center;
                align-items center;
                flex-direction column;
                user-select: none;
                transition: all 0.3s ease-in-out;
                position: relative;
                text-align: center;
                margin-bottom 16px;
                &.active-icon
                    .item-icon-wrapper
                        background: var(--bg-color-side-view-icon);
                        .item-icon
                            cursor initial
                            color: var(--svg-color-active);
                    .item-text
                        color: var(--themeColor);
                .item-icon-wrapper
                    width: 32px;
                    height: 32px;
                    border-radius: 6px;
                    padding 4px;
                    &:hover
                        background-color var(--hover-color-common)
                    .item-icon
                        cursor: pointer;
                        vertical-align: middle;
                        width: 24px;
                        height: 24px;
                        color: var(--svg-color-primary);
                .item-text
                    color: var(--text-color-primary);
                    line-height 16px;
                    max-width 42px;
                    white-space: wrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
        .left-panel-view-area
            background-color $right-view-backcolor
            position: absolute;
            pointer-events: auto;
            left: 48px;
            width 250px;
            top: 0;
            bottom: 0;
            transition: transform 0.3s ease-out;
            border-left: 1px solid var(--border-color-left-panel);
            border-right: 1px solid var(--border-color-left-panel);
            transform: scale(1);
            &.unshow
                border-right: none;
                .library-area
                    .Library-mask, .library-addshape
                        display none;
            >div
                height: 100%
                overflow: auto;
                overflow-y: overlay;
                .panel-view
                    user-select: none
</style>

<template>
    <div ref="leftPanel" class="leftPanel" :style="{ width: sceneLeft }" v-show="!isPreviewView && showLibrary">
        <div class="panel-menu">
            <div class="panel-normalmenu">
                <div
                    class="panel-menu-link"
                    v-for="(item, key, index) in pics"
                    :key="index"
                    @click="handleClickItem(item, key)"
                    :class="{ 'active-icon': activeKey === key }"
                    :content="$t(item.tips)"
                    v-tippy="{ placement: 'right' }"
                >
                    <!-- <iconSymbol v-if="currentView==key" class="item-icon" :name="item.activename"></iconSymbol> -->
                    <!-- <iconSymbol class="item-icon" :class="{'active-icon': activeKey === key}" :name="item.name"></iconSymbol> -->
                    <div class="item-icon-wrapper">
                        <iconSymbol class="item-icon" :name="item.svg" />
                    </div>
                    <span class="item-text" :style="{ fontSize: lang === 'zh' ? '12px' : '8px', lineHeight: lang === 'zh' ? '16px' : '12px' }">
                        {{ $t(item.text) }}
                    </span>
                </div>
            </div>
        </div>
        <div
            ref="leftPanelViewArea"
            class="left-panel-view-area"
            id="leftPanelViewArea"
            :style="{ width: leftPanelContent }"
            :class="showLeftPanel ? 'show' : 'unshow'"
        >
            <keep-alive>
                <component class="panel-view inner-scrollbar" :is="activeComp"></component>
            </keep-alive>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";

    @Component({
        components: {
            Library: () => import("./Common/Library.vue"),
            icon: () => import("./LeftPanel/Iconfont.vue"),
            echart: () => import("./LeftPanel/Chart.vue"),
            pixabay: () => import("./LeftPanel/Pixabay.vue"),
            more: () => import("./LeftPanel/More.vue"),
            IText: () => import("./LeftPanel/IText.vue"),
        },
    })
    export default class LeftPanel extends Vue {
        pics = {
            template: {
                svg: "leftpanel-template",
                tips: "leftPanel.tipsList.template",
                text: "leftPanel.textList.template",
                trackEvent: "leftReTemplate",
            },
            publicLibrary: {
                comp: "library",
                svg: "leftpanel-publiclibrary",
                tips: "leftPanel.tipsList.publicLibrary",
                text: "leftPanel.textList.publicLibrary",
                trackEvent: "leftReDiagramShapes",
            },
            myLibrary: {
                comp: "library",
                svg: "leftpanel-mylibrary",
                tips: "leftPanel.tipsList.myLibrary",
                text: "leftPanel.textList.myLibrary",
                trackEvent: "leftReMylibrary",
            },
            pixabay: {
                comp: "pixabay",
                svg: "leftpanel-image",
                tips: "leftPanel.tipsList.image",
                text: "leftPanel.textList.image",
                trackEvent: "leftRePicture",
            },
            echart: {
                comp: "echart",
                svg: "leftpanel-echart",
                tips: "leftPanel.tipsList.echart",
                text: "leftPanel.textList.echart",
                trackEvent: "leftReGraphs",
            },
            text: {
                comp: "IText",
                svg: "leftpanel-text",
                tips: "leftPanel.tipsList.text",
                text: "leftPanel.textList.text",
                trackEvent: "leftReText",
            },
            icon: {
                comp: "icon",
                svg: "leftpanel-icon",
                tips: "leftPanel.tipsList.icon",
                text: "leftPanel.textList.icon",
                trackEvent: "leftReIcons",
            },
            more: {
                comp: "more",
                svg: "leftpanel-more",
                tips: "leftPanel.tipsList.more",
                text: "leftPanel.textList.more",
                trackEvent: "leftReMoretools",
            },
        };
        maxWidth = 298;
        minWidth = 48;

        iconMargin: number = 14;
        iconTimer: number = 0;

        prevKey: string | null = "publicLibrary";

        showLeftPanel = true;

        activeKey: string | null = "publicLibrary";

        activeComp: string | null = "library";

        get isFocusMode() {
            return this.$store.state.ui.isFocusMode;
        }
        get focusExpand() {
            return this.$store.state.ui.focusExpand;
        }
        get focusModeExpandTop() {
            return this.$store.getters.expandTop;
        }
        get focusModeExpandRight() {
            return this.$store.getters.expandRight;
        }
        get focusModeExpandBottom() {
            return this.$store.getters.expandBottom;
        }
        get focusModeExpandLeft() {
            return this.$store.getters.expandLeft;
        }

        get sceneTop() {
            if (!this.focusModeExpandTop) return 0;
            return this.$store.state.ui.sceneTop + "px";
        }

        get sceneBottom() {
            if (!this.focusModeExpandBottom) return 0;
            return 35 + "px";
        }
        get sceneLeft() {
            if (!this.focusModeExpandLeft) return 0;
            return this.$store.state.ui.sceneLeft + "px";
        }

        set sceneLeft(v: number | string) {
            this.$store.commit("setStatus", {
                type: "sceneLeft",
                data: v,
            });
        }

        get leftPanelContent() {
            if (!this.focusModeExpandLeft) return 0;
            return this.$store.state.ui.sceneLeft - 48 + "px";
        }

        get isPreviewView() {
            return this.$store.state.ui.isPreviewView;
        }

        get expandLeft() {
            return this.$store.getters.expandLeft;
        }
        get showLibrary() {
            return this.expandLeft && this.$store.state.ui.showLibrary;
        }

        get sidePanelAnimationing() {
            return this.$store.state.ui.sidePanelAnimationing;
        }
        set sidePanelAnimationing(v) {
            this.$store.commit("setStatus", {
                type: "sidePanelAnimationing",
                data: v,
            });
        }

        handleClickItem(item, key) {
            if (this.sidePanelAnimationing) return;
            let trackProperty = item.trackEvent === "leftReGraphs" ? { click_tab: "null" } : {};
            this.sensors.track(item.trackEvent, {
                Catalogues: "leftResource",
                ...trackProperty,
            });
            if (key === "template") {
                this.$bus.$emit("showMoreTemplates");
                return;
            }

            if (key === "publicLibrary" || key === "myLibrary") {
                this.$store.commit("setLibraryState", {
                    type: "libraryType",
                    data: key,
                });
                let preScreenLeft = parseInt(this.sceneLeft + "");
                if (preScreenLeft === this.minWidth) {
                    this.sceneLeft = this.maxWidth;
                }
            } else {
                this.sceneLeft = this.maxWidth;
            }

            let dom = this.$refs.leftPanelViewArea as HTMLDivElement;
            if (this.prevKey === key) {
                let preScreenLeft = parseInt(this.sceneLeft + "");
                let endScreenLeft = this.minWidth;
                this.sceneLeft = endScreenLeft;
                this.showLeftPanel = false;
                this.prevKey = null;
                this.activeKey = null;
                this.$bus.$emit("sidePanelAnimation", "left", preScreenLeft, endScreenLeft);
                this.updatePositionAnimation(dom, "width", preScreenLeft - 48, endScreenLeft - 48);
            } else {
                if (!this.prevKey) {
                    this.$bus.$emit("sidePanelAnimation", "left", this.minWidth, this.maxWidth);
                    this.updatePositionAnimation(dom, "width", this.minWidth - 48, this.maxWidth - 48);
                }
                this.showLeftPanel = true;
                this.activeKey = key;
                this.prevKey = key;
                this.activeComp = item.comp;
            }
        }

        updatePositionAnimation(dom, type, start, end, duration = 400) {
            this.sidePanelAnimationing = true;
            this.$bus.$emit("ft_closeChildExpand"); // 关闭浮动工具栏弹窗
            let startTime;
            let resolve = null;
            let updatePosition = (dom, type, data) => {
                dom.style[type] = `${data}px`;
            };
            let easeOutExpo = (t, b, c, d) => {
                return t == d ? b + c : c * (-Math.pow(2, (-10 * t) / d) + 1) + b;
            };
            const resizeFunc = () => {
                window["_view"].onsize();
            };
            let step = (timestamp) => {
                !startTime && (startTime = timestamp);
                const stepp = Math.min((timestamp - startTime) / duration, 1);
                const changed = easeOutExpo(stepp, start, end - start, 1);
                updatePosition(dom, type, changed);
                if (stepp != 1) {
                    resizeFunc();
                    window.requestAnimationFrame(step);
                } else {
                    resizeFunc();
                    setTimeout(() => {
                        // 避开触发scroll事件
                        resolve();
                        this.sidePanelAnimationing = false;
                    }, 30);
                }
            };
            return new Promise((s) => {
                resolve = s;
                window.requestAnimationFrame(step);
            });
        }

        mounted() {
            this.$bus.$on("showShepherd", () => {
                if (this.isPreviewView) {
                    return;
                }
                if (!this.showLeftPanel) {
                    this.handleClickItem(this.pics.publicLibrary, "publicLibrary");
                }
            });
        }
        created() {
            if (!window.EDCONFIG.MY_LIBRARY_ENABLE) {
                delete this.pics.myLibrary;
            }
            if (!window.EDCONFIG.ICONFONT_ENABLE) {
                delete this.pics.icon;
            }
            if (!window.EDCONFIG.PIXABAY_ENABLE) {
                delete this.pics.pixabay;
            }
            if (!window.EDCONFIG.TEMPLATE_ENABLE) {
                delete this.pics.template;
            }
        }

        beforeDestroy() {}
    }
</script>
<i18n>
    {
      "zh": {
        "leftPanel": {
          "tipsList": {
                "template": "模版",
                "publicLibrary": "符号形状",
                "myLibrary": "我的符号库",
                "image": "图片",
                "icon": "图标",
                "echart": "图表",
                "text": "文字",
                "more": "更多工具"
            },
          "textList": {
                "template": "模版",
                "publicLibrary": "符号",
                "myLibrary": "我的库",
                "image": "图片",
                "icon": "图标",
                "echart": "图表",
                "text": "文字",
                "more": "更多"
            }
        }
      },
      "en": {
         "leftPanel": {
            "tipsList": {
                "template": "Templates",
                "publicLibrary": "Diagram Symbols",
                "myLibrary": "My Symbol Library",
                "image": "Pictures",
                "icon": "Icons",
                "echart": "Graphs",
                "text": "Text",
                "more": "More Tools"
            },
            "textList": {
                "template": "Templates",
                "publicLibrary": "Symbols",
                "myLibrary": "My Library",
                "image": "Pictures",
                "icon": "Icons",
                "echart": "Graphs",
                "text": "Text",
                "more": "More"
            }
        }
      },
      "fr": {
         "leftPanel": {
            "tipsList": {
                "template": "Communauté de modèles",
                "publicLibrary": "Formes de diagramme",
                "myLibrary": "Ma bibliothèque de formes",
                "image": "Images",
                "icon": "Icônes",
                "echart": "Graphiques",
                "text": "Texte",
                "more": "Plus d'outils"
            },
            "textList": {
                "template": "Modèles",
                "publicLibrary": "Formes",
                "myLibrary": "Ma bibliothèque",
                "image": "Images",
                "icon": "Icônes",
                "echart": "Graphiques",
                "text": "Texte",
                "more": "Plus"
            }
        }
      },
      "de": {
         "leftPanel": {
            "tipsList": {
                "template": "Vorlagen-Community",
                "publicLibrary": "Diagrammformen",
                "myLibrary": "Meine Formbibliothek",
                "image": "Bilder",
                "icon": "Symbole",
                "echart": "Diagramme",
                "text": "Text",
                "more": "Mehr Werkzeuge"
            },
            "textList": {
                "template": "Vorlagen",
                "publicLibrary": "Formen",
                "myLibrary": "Bibliothek",
                "image": "Bilder",
                "icon": "Symbole",
                "echart": "Graphen",
                "text": "Text",
                "more": "Mehr"
            }
        }
      },
      "jp": {
         "leftPanel": {
            "tipsList": {
                "template": "テンプレート",
                "publicLibrary": "ダイアグラムの形状",
                "myLibrary": "私のシェイプライブラリ",
                "image": "画像",
                "icon": "アイコン",
                "echart": "グラフ",
                "text": "テキスト",
                "more": "その他のツール"
            },
            "textList": {
                "template": "テンプレート",
                "publicLibrary": "図形",
                "myLibrary": "ライブラリ",
                "image": "画像",
                "icon": "アイコン",
                "echart": "グラフ",
                "text": "テキスト",
                "more": "その他"
            }
        }
      },
      "es": {
         "leftPanel": {
            "tipsList": {
                "template": "Comunidad",
                "publicLibrary": "Formas de diagrama",
                "myLibrary": "Mi biblioteca de formas",
                "image": "Imágenes",
                "icon": "Iconos",
                "echart": "Gráficos",
                "text": "Texto",
                "more": "Más herramientas"
            },
            "textList": {
                "template": "Plantillas",
                "publicLibrary": "Formas",
                "myLibrary": "Mi biblioteca",
                "image": "Imágenes",
                "icon": "Iconos",
                "echart": "Gráficos",
                "text": "Texto",
                "more": "Más"
            }
        }
      },
      "pt": {
         "leftPanel": {
            "tipsList": {
                "template": "Comunidade de modelos",
                "publicLibrary": "Formas de diagrama",
                "myLibrary": "Minha biblioteca de formas",
                "image": "Imagens",
                "icon": "Ícones",
                "echart": "Gráficos",
                "text": "Texto",
                "more": "Mais ferramentas"
            },
            "textList": {
                "template": "Modelos",
                "publicLibrary": "Formas",
                "myLibrary": "Biblioteca",
                "image": "Imagens",
                "icon": "Ícones",
                "echart": "Gráficos",
                "text": "Texto",
                "more": "Mais"
            }
        }
      },
      "it": {
         "leftPanel": {
            "tipsList": {
                "template": "Comunità di modelli",
                "publicLibrary": "Forme di diagramma",
                "myLibrary": "La mia biblioteca di forme",
                "image": "Immagini",
                "icon": "Icone",
                "echart": "Grafici",
                "text": "Testo",
                "more": "Altri strumenti"
            },
            "textList": {
                "template": "Modelli",
                "publicLibrary": "Forme",
                "myLibrary": "Le mie librerie",
                "image": "Immagini",
                "icon": "Icone",
                "echart": "Grafici",
                "text": "Testo",
                "more": "Altro"
            }
        }
      },
      "tw": {
         "leftPanel": {
            "tipsList": {
                "template": "模板",
                "publicLibrary": "圖表形狀",
                "myLibrary": "我的形狀庫",
                "image": "圖片",
                "icon": "圖標",
                "echart": "圖表",
                "text": "文字",
                "more": "更多工具"
            },
            "textList": {
                "template": "範本",
                "publicLibrary": "形狀",
                "myLibrary": "我的庫",
                "image": "影像",
                "icon": "圖示",
                "echart": "圖表",
                "text": "文字",
                "more": "更多"
            }
        }
      },
      "kr": {
         "leftPanel": {
            "tipsList": {
                "template": "템플릿 갤러리",
                "publicLibrary": "다이어그램 형태",
                "myLibrary": "나의 도형 라이브러리",
                "image": "사진",
                "icon": "아이콘",
                "echart": "그래프",
                "text": "텍스트",
                "more": "더 많은 도구"
            },
            "textList": {
                "template": "템플릿",
                "publicLibrary": "도형",
                "myLibrary": "내 라이브러리",
                "image": "이미지",
                "icon": "아이콘",
                "echart": "그래프",
                "text": "텍스트",
                "more": "더 보기"
            }
        }
      }
    }
</i18n>
